import { render } from "./SpaDayTreatmentTimes.vue?vue&type=template&id=22d6ecfd&scoped=true"
import script from "./SpaDayTreatmentTimes.vue?vue&type=script&lang=js"
export * from "./SpaDayTreatmentTimes.vue?vue&type=script&lang=js"

import "@/shared/css/guests.css?vue&type=style&index=0&lang=css&external"
import "./SpaDayTreatmentTimes.vue?vue&type=style&index=1&id=22d6ecfd&scoped=true&lang=css"
import "./SpaDayTreatmentTimes.vue?vue&type=style&index=2&id=22d6ecfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d6ecfd"]])

export default __exports__